import { render, staticRenderFns } from "./AnniversaryCard.vue?vue&type=template&id=0371d4ea&scoped=true&"
import script from "./AnniversaryCard.vue?vue&type=script&lang=js&"
export * from "./AnniversaryCard.vue?vue&type=script&lang=js&"
import style0 from "./AnniversaryCard.vue?vue&type=style&index=0&id=0371d4ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0371d4ea",
  null
  
)

export default component.exports